import gql from 'graphql-tag';
import { scheduledSessionFieldsFragment } from '../fragments';

export const completeScheduledSessionMutation = gql`
  mutation CompleteScheduledSession($id: ID!) {
    completeScheduledSession(id: $id) {
      ...AdminScheduledSessionFields
    }
  }

  ${scheduledSessionFieldsFragment}
`;